export class RoutesConstants {
  static LOGIN_PAGE_URL = 'login';
  static FORGET_PASSWORD_PAGE_URL = 'forget-password';
  static DASHBOARD_PAGE_URL = 'dashboard';
  // dashboard
  static DASHBOARD_PAGE_BALANCE_MINUTES_URL = 'balance-minutes-report-graph';
  static DASHBOARD_PAGE_PEAK_URL = 'peak-report-graph';
  static DASHBOARD_WL_PAGE_URL = 'dashboard-wl';
  static REVIEWS_REPORT_PAGE_URL = 'reviews-report';
  static DEPENDENTS_REPORT_PAGE_URL = 'dependents-report';
  static STUDENT_PERFORMANCE_REPORT_PAGE_URL = 'beneficiary-performance-report';
  static TEACHERS_PERFORMANCE_REPORT_PAGE_URL = 'consultants-performance-report';
  static BLOCKED_STUDENTS_REPORT_PAGE_URL = 'blocked-beneficiaries-report';
  static CALLS_DETAILS_REPORT_PAGE_URL = 'calls-details-report';
  static CALLS_REPORT_PAGE_URL = 'calls-report';
  static STUDENTS_REPORT_PAGE_URL = 'beneficiaries-report';
  static TEACHERS_REPORT_PAGE_URL = 'consultants-report';
  static REVIEWERS_REVIEWS_REPORT_PAGE_URL = 'reviewers-reviews-report';
  static BALANCE_REPORT_PAGE_URL = 'balance-report';
  static SESSIONS_REPORT_PAGE_URL = 'sessions-report';
  static TEACHER_ONLINE_MINUTES_REPORT_PAGE_URL = 'consultant-online-minutes-report';
  static PEAK_HOURS_REPORT_PAGE_URL = 'peak-hours-report';
  static MESSAGES_REPORT_PAGE_URL = 'messages-report';
  static RESERVATIONS_REPORT_PAGE_URL = 'reservations-report';
  static PAY_TABS_REPORT_PAGE_URL = 'paytabs-report';
  static SURVEYS_REPORT_PAGE_URL = 'surveys-report';
  static STORE_RATINGS_REPORT_PAGE_URL = 'store-ratings-report';
  static STUDENT_DETAILS_REPORT_PAGE_URL = 'beneficiary-details-report';
  static BENEFICIARIES_REPORT_PAGE_URL = 'beneficiary-list-report';
  static DONATIONS_REPORT_PAGE_URL = 'donations-report';
  static TOTAL_DURATION_REPORT_PAGE_URL = 'total-duration-report';
  static STUDENTS_PLANS_REPORT_PAGE_URL = 'beneficiaries-plans-report';
  static TEACHERS_PLANS_REPORT_PAGE_URL = 'consultants-plans-report';
  static TEACHER_RESERVATION_REPORT_PAGE_URL = 'consultant-reservation-report';
  static CUSTOMER_SUPPOR_REPORT_PAGE_URL = 'customer-support';
  static FREE_CODES_REPORT_PAGE_URL = 'freecodes-report';
  static FATIHA_SESSIONS_REPORT_PAGE_URL = 'fatiha-sessions';

  // manage users accounts
  static UPDATE_TEACHERS_INFO_REQUESTS_PAGE_URL = 'update-consultants-info-requests';
  static USERS_PERMISSIONS_PAGE_URL = 'users-permissions';
  static USERS_PERMISSIONS_ADD_WHITLELABEL_USER_PAGE_URL = 'users-permissions/add-whitelabel-user';
  static USERS_PERMISSIONS_ADD_USER_PAGE_URL = 'users-permissions/add-user';
  static STUDENT_JOIN_US_REQUEST_PAGE_URL = 'beneficiary-join-us-request';
  static USERS_REPORTS_PAGE_URL = 'reports';
  static UPGRADE_STUDENTS_REQUESTS_PAGE_URL = 'upgrade-beneficiaries-request';
  static STUDENT_ACCOUNT_MANAGEMENT_PAGE_URL = 'beneficiaries-management';
  static STUDENT_ACCOUNT_DEPENDENTS_MANAGEMENT_PAGE_URL = 'dependents-management';
  static TEACHER_JOIN_REQUEST_PAGE_URL = 'consultant-join-us-requests';
  static STUDENT_PACKAGES_PAGE_URL = 'beneficiary-packages';
  static BENEFICIARIES_PAGE_URL = 'beneficiary-list';
  static RECEIVABLES_PAGE_URL = 'receivables';
  static CONSULTANT_BALANCE_PAGE_URL = 'consultant-balance';

  // control settings
  static GENERAL_CONFIGURATIONS_PAGE_URL = 'general-config';
  static ADD_MINUTES_PAGE_URL = 'add-minutes';
  static CATEGORIES_PAGE_URL = 'category';
  static TEACHER_CATEGORIES_PAGE_URL = 'get-consultant-category';
  static TEACHERS_PAGE_URL = 'consultants';
  static DISCOUNT_CODES_PAGE_URL = 'discount-codes';
  static DYNAMIC_LINKS_PAGE_URL = 'dynamicLinks';
  static GET_FREE_CODES_PAGE_URL = 'free-codes';
  static ADS_PAGE_URL = 'banners';
  static PEAK_HOURS_PAGE_URL = 'peak-hours';
  static CALL_SHARED_FILES_PAGE_URL = 'call-shared-files';
  static FAQ_CATEGORIES_PAGE_URL = 'help-categories';
  static FAQ_PAGE_URL = 'faqs';
  static FAQ_EDITOR_PAGE_URL = 'faqs-add-edit';
  static SCHEDULED_NOTIFICATIONS_PAGE_URL = 'scheduled-notification';

  // sessions
  static SESSIONS_PAGE_URL = 'sessions';

  // user profile
  static USER_PROFILE_PAGE_URL = 'profile';

  // marketplace
  static MARKETPLACE_PACKAGES_PAGE_URL = 'packages';
  static PACKAGE_EDITOR_PAGE_URL = 'packages-edit';
  static PACKAGE_ADD_PAGE_URL = 'packages-add';
  static MARKETPLACE_PRODUCTS_PAGE_URL = 'products';

  // send message
  static SEND_MESSAGE = 'send-message';

  // uploads
  static UPLOAD_TEACHERS_FILES = 'upload-consultants';
  static UPLOAD_STUDENTS_FILES = 'upload-beneficiaries';
  static UPLOAD_STUDENTS_PLANS_FILES = 'upload-beneficiaries-plan';
  static UPLOAD_UPDATE_STUDENTS_FILES = 'upload-update-beneficiaries';
  static SHOW_TEACHERS_FILES = 'show-consultants';
  static SHOW_STUDENTS_FILES = 'show-beneficiaries';
  static SHOW_UPDATE_STUDENTS_FILES = 'show-update-beneficiaries';
  static SHOW_STUDENTS_PLANS_FILES = 'show-beneficiaries-plans';

  //export reports
  static EXPORT_REPORTS_PAGE_URL = 'exportedReports';

  // no permission
  static NO_PERMISSION_PAGE_URL = 'not-have-permission';

  // add new teacher
  static ADD_NEW_TEACHER_PAGE_URL = 'add-consultant';

  //send-insolvent-code
  static SEND_INSOLVENT_CODE_PAGE_URL = 'send-insolvant-code';

  // White labels
  static WHITE_LABEL_PATH_URL = 'wl';

  static THEME_ERROR_PAGE_URL = 'theme-error';

  //fatiha requests
  static FATIHA_REQUESTS_PAGE_URL = 'fatiha-requests';
}
